import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
/***
 * Check of the User is a Caseworker
 */
@Injectable({
  providedIn: 'root'
})
export class RoleCaseworkerGuard  {
  /**
   * constructor
   * @param router 
   * @param authenticationService 
   */
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  /**
   * Check if the User is a Caseworker
   * @param route 
   * @param state 
   * @returns 
   */
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.decodedToken$.value;
    if (currentUser.role == "ROLE_CASEWORKER") {
      // logged in so return true
      return true;
    }
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/']);
    return false;
  }
}
